import { atom } from "jotai";
import { Selector } from "@/model";

export const editingSelectorAtom = atom<Selector|undefined>();